export default __webpack_public_path__ + "static/building-9bcd74693dc99397250cf1b67b3f7537.svg";